/**
 * @file operations.ts
 * @module api/apiJSON/operations
 * @description Defines Operations module API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.4.1
 */

import { IBranchHealthParams } from "../../types";

export const operationsJSON = {
  branchHealth: ({ branchId }: IBranchHealthParams) => {
    const params: any = {};
    if (branchId) {
      params.branchId = branchId;
    }
    return params;
  },
};
